import Flickity from './FlickityExtended';

// const AUTOPLAY_CLASS = 'slider--autoplay';

// Add autoplay events
// We can now listen for the events:
// playPlayer, stopPlayer, pausePlayer, unpausePlayer
[('play', 'stop', 'pause', 'unpause')].forEach(action => {
    let methodName = action + 'Player';
    Flickity.prototype[methodName] = function() {
        this.player[action]();
        this.dispatchEvent(methodName);
    };
});

export default Flickity;
